import { StyleSheet } from 'react-native';

const baseStyles = {
    container: {
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center'
    },
    title: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    text: {
        color: '#00A0DE'
    },
    icon: {
        marginRight: 20
    }
};

export default StyleSheet.create(baseStyles);
